import { render, staticRenderFns } from "./v-textarea.vue?vue&type=template&id=4f5211fa&"
import script from "./v-textarea.vue?vue&type=script&lang=js&"
export * from "./v-textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports